export default "/images/framework/WordWalletEng.ae705bb5.svg?ae705bb5";